import { AnimatePresence } from "motion/react";
import SimpleOverlay from "../modal/SimpleOverlay";
import CockpitLayoutComponents from "../CockpitLayoutComponents";
import { usePageFragment } from "../../hooks/CmsHooks";

export function PopupFragment({
  fragmentId,
  show = false,
  onClose = () => {}
}) {
  const fragment = usePageFragment(fragmentId);
  if (!fragment) {
    console.warn("Unknown page fragment " + fragmentId);
    return null;
  }

  return (
    <AnimatePresence>
      {show && (
        <SimpleOverlay
          key={"fragment-" + fragmentId}
          close={() => {
            onClose();
          }}
          className="simple-overlay-mini"
        >
          <CockpitLayoutComponents
            withSectionNav
            components={fragment.content}
            direction={"horizontal"}
          />
        </SimpleOverlay>
      )}
    </AnimatePresence>
  );
}
